
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zoko-alternative",
      function () {
        return require("private-next-pages/zoko-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zoko-alternative"])
      });
    }
  